import { BadgeCategory, BadgeCategoryWarningType, UserRight } from '@biteinc/enums';
import { SyncableMenuModelSchema } from './syncable_menu_model_schema.js';
export const badgeSchema = {
    displayName: 'badge',
    type: 'object',
    fields: {
        ...SyncableMenuModelSchema.fields,
        vendorId: {
            type: 'mongoId',
            displayName: 'Vendor',
            isHidden: true,
            isReadOnly: true,
        },
        name: {
            type: 'shortString',
            canHaveLocalizationOverrides: true,
        },
        internalName: {
            type: 'shortString',
            displayName: 'Internal Name',
            collapse: true,
            tooltip: {
                text: 'A name used to identify this item internally. Not seen by guests.',
            },
            writeRight: UserRight.ManageMenu,
        },
        posName: {
            type: 'shortString',
            displayName: 'POS Name',
            isReadOnly: true,
            tooltip: {
                text: 'This is the default display name. The field “Display Name” will replace this name on the kiosk.',
            },
        },
        posInternalName: {
            type: 'keyString',
            isReadOnly: true,
            isHidden: true,
        },
        filterCategory: {
            displayName: 'Filter Category',
            type: 'stringEnum',
            enum: BadgeCategory,
            ui: 'dropdown',
            tooltip: {
                text: 'Add the filter to a category for grouping',
            },
            writeRight: UserRight.ManageChannelSettings,
            required: true,
        },
        warningType: {
            type: 'stringEnum',
            enum: BadgeCategoryWarningType,
            ui: 'dropdown',
            tooltip: {
                text: 'The type of warning to display',
            },
            writeRight: UserRight.ManageChannelSettings,
            required: true,
            conditions: [
                {
                    field: 'filterCategory',
                    values: [BadgeCategory.Warning],
                },
            ],
        },
        showOnItemsAndMods: {
            type: 'bool',
            displayName: 'Show on Menu Items and Mods',
            required: true,
            defaultValue: true,
            conditions: [
                {
                    field: 'filterCategory',
                    values: [
                        BadgeCategory.Restrictive,
                        BadgeCategory.Dietary,
                        BadgeCategory.Other,
                        BadgeCategory.Warning,
                    ],
                },
            ],
        },
        icons: {
            tooltip: {
                text: 'Displayed in the menu, excluded from the quiz.',
            },
            type: 'array',
            elementType: 'object',
            elementSubtype: 'Image',
            elementUniqueIdFieldName: 'origUrl',
            required: true,
            maxCount: 1,
            forceCrop: true,
            size: {
                width: 50,
                height: 50,
            },
        },
        quizIcons: {
            displayName: 'Quiz Icons',
            type: 'array',
            elementType: 'object',
            elementSubtype: 'Image',
            elementUniqueIdFieldName: 'origUrl',
            minCount: 1,
            maxCount: 1,
            size: {
                width: 400,
                height: 400,
            },
        },
    },
};
//# sourceMappingURL=badge_schema.js.map